export const margin = `
  margin-inline: auto;
  width: 1080px;
`